module.exports = __webpack_public_path__ + "img/full.21b99539.png";